<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onEditAndSaveClick)="doEditAndSave($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div class="jk-grid-cols-4"> 
    <app-jkedit  label="customId" #MC020Com  id="MC020"  [(value)]="item.MC020" [required]="true"  placeholder="customId"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="流水號" #MC002Com  id="MC002"  [(value)]="item.MC002" [required]="true"  placeholder="流水號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="類別" #MC010Com  id="MC010"  [(value)]="item.MC010" placeholder="類別"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="MAC_Address" #MC004Com  id="MC004"  [(value)]="item.MC004" placeholder="MAC_Address"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="電腦名稱" #MC011Com  id="MC011"  [(value)]="item.MC011" placeholder="電腦名稱"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="資料" #MC006Com  id="MC006"  [(value)]="item.MC006" placeholder="資料"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="帳號" #MC007Com  id="MC007"  [(value)]="item.MC007" placeholder="帳號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="密碼" #MC008Com  id="MC008"  [(value)]="item.MC008" placeholder="密碼"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="外部IP" #MC003Com  id="MC003"  [(value)]="item.MC003" placeholder="外部IP"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="內部IP" #MC009Com  id="MC009"  [(value)]="item.MC009" placeholder="內部IP"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktextarea  height="250px" 
 label="備註" #MC005Com  id="MC005"  [(value)]="item.MC005" placeholder="備註"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkcheckboxYN  label="alwaysOn" #MC012Com  id="MC012"  [(valueYN)]="item.MC012"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jkedit  label="VM主機" #MC013Com  id="MC013"  [(value)]="item.MC013" placeholder="VM主機"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkdatefield  label="偵測時間" #MC014Com  id="MC014"  [(date)]="item.MC014" placeholder="偵測時間"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>
    <app-jkcheckboxYN  label="isOnline" #MC015Com  id="MC015"  [(valueYN)]="item.MC015"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jkedit  label="shutdownAPI" #MC016Com  id="MC016"  [(value)]="item.MC016" placeholder="shutdownAPI"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="rebootAPI" #MC017Com  id="MC017"  [(value)]="item.MC017" placeholder="rebootAPI"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jknumberedit  label="apiPort" #MC018Com  id="MC018"  [(value)]="item.MC018" placeholder="apiPort"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jkedit  label="platform" #MC019Com  id="MC019"  [(value)]="item.MC019" placeholder="platform"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktext  label="上次開機時間" [value]="item.MC021"     >
    </app-jktext>
    <app-jkedit  label="編號" #MC001Com  id="MC001"  [(value)]="item.MC001" [required]="true"  placeholder="編號"  [readonly]="isBrowse"     >
    </app-jkedit>

    </div>
  </div>
</div>
